export type DocumentKind = 'pdf' | 'docx' | 'unknown';

/**
 * Bepaalt het viewer-type op basis van de bestandsextensie.
 * Elk type routeert naar een eigen weergave: 'docx' → DocumentDocxPanel,
 * 'pdf' → DocumentPdfPanel (ongewijzigd gedrag), 'unknown' → een placeholder
 * voor niet-ondersteunde of beschadigde bestanden.
 */
export function resolveDocumentKind(name: string | null | undefined): DocumentKind {
  if (!name) return 'unknown';
  const dot = name.lastIndexOf('.');
  if (dot === -1 || dot === name.length - 1) return 'unknown';
  const ext = name.slice(dot + 1).toLowerCase();
  if (ext === 'pdf') return 'pdf';
  if (ext === 'docx') return 'docx';
  return 'unknown';
}
